export const environment = {
    apiUrl: 'https://api.ifeet.app',
    production: true,
    version: '1.7.2'
};
